import React, { useContext } from 'react';
import RoundButton from '../../../../components/RoundButton';
import { Context } from '../../../../context/AppContext';
import './styles.css';

const Clear = ({ fetchMore, children }) => {
  const {
    media: { desktop, mobile },
  } = useContext(Context);
  return (
    <RoundButton
      className="Listview__Filters__Clear__root"
      type="button"
      size="small"
      icon={<i className="icon-generalrefresh" />}
      onClick={e =>
        fetchMore(e, {
          page: 0,
          sort: undefined,
          filter: undefined,
        })
      }
    >
      {(desktop || mobile) && children}
    </RoundButton>
  );
};

export default Clear;
